<template>
  <div id="contact-form" class="section padding-bottom-big over-hide">
    <div class="container">
      <p class="mb-2  px-4 px-xl-2">{{ form.error }}</p>
      <div class="row px-4 px-xl-2">
        <form
          class="col-lg-9 form"
          @submit.prevent="submitForm"
          autocomplete="on"
        >
          <fieldset :disabled="submitting" class="ajax-form">
            <div class="row">
              <div class="col-md-12">
                <input
                  v-model="form.name"
                  name="name"
                  autocomplete="name"
                  type="text"
                  placeholder="Your Name: *"
                  required
                />
              </div>
              <div class="col-md-6 mt-4">
                <input
                  v-model="form.email"
                  name="email"
                  autocomplete="email"
                  type="email"
                  placeholder="E-Mail: *"
                  required
                />
              </div>
              <div class="col-md-6 mt-4">
                <input
                  v-model="form.phone"
                  name="phone"
                  autocomplete="tel"
                  type="tel"
                  placeholder="Phone Number:"
                  required
                />
              </div>

              <div class="col-md-6 mt-4">
                <input
                  v-model="form.company"
                  name="company"
                  autocomplete="company"
                  type="text"
                  placeholder="Company Name:"
                />
              </div>
              <div class="col-md-6 mt-4">
                <input
                  v-model="form.website"
                  name="website"
                  type="text"
                  placeholder="Website:"
                />
              </div>
              <div class="col-md-12 mt-4">
                <v-select
                  :class="{ whiteBack: form.interested.length > 0 }"
                  taggable
                  placeholder="Interested In"
                  multiple
                  v-model="form.interested"
                  :options="options"
                ></v-select>
              </div>
              <div class="col-md-12 mt-4">
                <textarea
                  v-model="form.message"
                  name="message"
                  placeholder="Tell Me Everything *"
                ></textarea>
              </div>
              <div class="col-md-12 mt-4">
                <button @submit="submitForm">
                  <span>submit</span>
                </button>
              </div>
            </div>
          </fieldset>

          <transition name="fade-in">
            <div class="submitting" v-if="submitting">
              <span class="d-flex">
                <div
                  :class="{
                    rotating: submitting && !submitted,
                    submitted: submitted
                  }"
                >
                  <svg
                    width="24pt"
                    height="24pt"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g>
                      <path
                        d="M 12 2 C 6.476563 2 2 6.476563 2 12 C 2 17.523438 6.476563 22 12 22 C 17.523438 22 22 17.523438 22 12 C 22 6.476563 17.523438 2 12 2 Z M 10 17.414063 L 5.292969 12.707031 L 6.707031 11.292969 L 10 14.585938 L 17.292969 7.292969 L 18.707031 8.707031 Z "
                      />
                    </g>
                  </svg>
                </div>
                <p class="mt-3" v-if="submitted === true">
                  Form Submitted Successfully
                </p>
                <small
                  class="mt-2"
                  role="button"
                  v-if="submitted === true"
                  @click="
                    submitting = false;
                    submitted = false;
                  "
                  >Send another message</small
                >
              </span>
            </div>
          </transition>
        </form>
        <div class="col-lg-3 mt-4 mt-lg-0">
          <div class="section background-dark-4 p-4 contact-info">
            <h6 class="mb-3">Call Me</h6>
            <a class="mb-0" href="tel:+2347062180970">+234 706 218 0970</a>
            <a class="mb-4" href="tel:+2347010213496">+234 701 021 3496</a>
            <h6 class="mb-3">Chat with Me</h6>
            <p class="mb-4">
              WhatsApp<br />
              <a class="mb-0" href=" https://wa.me/2347010213496"
                >+234 701 021 3496</a
              >
            </p>
            <h6 class="mb-3">Email Me</h6>
            <a class="mb-0" href="mailto:hello@adomokai.dev"
              >hello@adomokai.dev</a
            >
            <a class="mb-0" href="mailto:shox@adomokai.dev"
              >shox@adomokai.dev</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { clientsCollection } from "../firebase-config";
import axios from "axios";
export default {
  components: {
    vSelect
  },
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        interested: [],
        company: "",
        website: "",
        message: "",
        error: ""
      },
      blankForm: {
        name: "",
        email: "",
        phone: "",
        interested: [],
        company: "",
        website: "",
        message: "",
        error: ""
      },
      options: [
        "Web Design",
        "Branding",
        "Illustrations",
        "UI/UX",
        "Graphics Design"
      ],
      submitting: false,
      submitted: false
    };
  },
  methods: {
    async submitForm() {
      this.submitting = true;
      this.form.error = "";
      try {
        await clientsCollection.add({
          createdOn: new Date(),
          name: this.form.name,
          email: this.form.email,
          phone: this.form.phone,
          interested: this.form.interested ? this.form.interested : "NA",
          company: this.form.company,
          website: this.form.website,
          message: this.form.message
        });

        await axios.get(
          `https://us-central1-shoxadomokai-portfolio.cloudfunctions.net/sendMail?name=${this.form.name}&email=${this.form.email}&phone=${this.form.phone}&company=${this.form.company}&website=${this.form.website}&interests=${this.form.interested}&message=${this.form.message}`
        );

        this.submitted = true;
        this.form = this.blankForm;
      } catch (err) {
        console.log(err.message);
        this.form.error = err.message;
        this.submitting = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "vue-select/src/scss/vue-select.scss";

.contact-info {
  a {
    display: block;
    color: #c4c3ca;

    &:hover {
      text-decoration: none;
      color: $primary;
    }
  }
}

.form {
  position: relative;

  .submitting {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: grid;
    place-items: center;
    background: black;
    transition: 0.3s opacity ease;

    span {
      flex-flow: column wrap;
      align-items: center;
    }

    small {
      cursor: pointer;
    }

    .rotating {
      width: 50px;
      height: 50px;
      border: 4px solid $primary;
      border-radius: 100%;
      border-top-color: black;
      border-left-color: black;
      animation: rotate 400ms linear infinite;
      animation-delay: 0.3s;

      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(360deg);
        }
      }
    }

    .submitted {
      width: 50px;
      height: 50px;
      background: $primary;
      border-radius: 100%;
      display: grid;
      place-items: center;

      svg {
        width: 50px;
        height: 50px;
      }
    }
  }

  .ajax-form {
    textarea {
      height: 170px;
    }

    input::placeholder {
      font-size: 15px;
      letter-spacing: 1px;
      color: rgba(255, 255, 255, 0.4);
      font-weight: 700;
    }

    input,
    textarea {
      position: relative;
      width: 100%;
      padding: 20px 20px;
      font-weight: 400;
      letter-spacing: 1px;
      font-size: 15px;
      line-height: 1.7;
      background-color: #14151a;
      color: #fff;
      border: none;
      text-align: left;
      cursor: text;
      transition: all 250ms linear;

      &:active,
      &:hover {
        color: #ccc;
      }

      &:focus {
        outline: none !important;
      }
    }

    button {
      color: rgba(255, 255, 255, 0.5);
      cursor: pointer;
      font-size: 15px;
      padding: 12px 25px;
      letter-spacing: 2px;
      background-color: #14151a;
      border: none;
      outline: none;
      margin: 0 auto;
      text-align: center;
      transition: all 250ms linear;

      &:focus,
      &:active {
        border: none;
        outline: none;
      }

      &:hover {
        background-color: $primary;
        color: black;
      }

      span {
        position: relative;
        display: block;
        cursor: pointer;
        transition: all 250ms linear;
      }
    }
  }
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}

/deep/ .v-select {
  .vs__actions {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);

    .vs__open-indicator {
      fill: rgba(255, 255, 255, 0.5);
      transition: 0.3 all ease-in;
    }
  }

  &.vs--open {
    .vs__actions {
      .vs__open-indicator {
        fill: $primary;
        transform: rotate(180deg);
      }
    }

    .vs__dropdown-menu {
      opacity: 1;
      pointer-events: auto;
      transform: translateY(0);
    }
  }

  .vs__dropdown-menu {
    opacity: 0;
    list-style: none;
    background-color: #09090c;
    pointer-events: none;
    border-radius: 0;
    box-sizing: border-box;
    margin-top: 1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 100%;
    box-shadow: 0 10px 6px -6px rgba(0, 0, 0, 0.4);
    left: 0;
    color: #ccc;
    top: 100%;
    transform-origin: 50% 0;
    transform: translateY(-15px);
    transition: all 0.3s linear, opacity 0.15s ease-out;
    z-index: 9;

    .vs__dropdown-option {
      cursor: pointer;
      font-weight: 400;
      font-size: 14px;
      letter-spacing: 1px;
      padding-top: 15px;
      padding-bottom: 15px;
      outline: none;
      padding-left: 20px;
      padding-right: 20px;
      text-align: left;
      transition: all 0.2s;

      &:hover {
        color: #fff;
        background-color: #353746;
      }
    }
  }

  &.whiteBack .vs__selected-options {
    color: #14151a;
    background-color: #e8f0fe;
    padding: 5px 20px;

    .vs__search {
      color: black;
    }
  }

  &.whiteBack .vs__actions {
    .vs__open-indicator {
      fill: black;
    }
  }

  .vs__selected-options {
    position: relative;
    width: 100%;
    padding: 20px;
    font-weight: 400;
    letter-spacing: 1px;
    font-size: 15px;
    line-height: 1.7;
    background-color: #14151a;
    color: #fff;
    border: none;
    text-align: left;
    cursor: pointer;
    transition: all 250ms linear;

    .vs__search {
      color: #fff;
      font-size: 15px;
      background: none;
      outline: none;
      border: none;

      &::placeholder {
        font-size: 15px;
        letter-spacing: 1px;
        color: rgba(255, 255, 255, 0.4);
        font-weight: 700;
      }
    }

    .vs__deselect {
      background: none;
      outline: none;
      border: none;
      padding-left: 10px;
    }

    .vs__selected {
      background-color: #353746;
      border-radius: 50px;
      padding: 5px 15px;
      font-weight: 900;
      color: white;
      margin: 10px 10px 10px 0;
      display: inline-block;
    }
  }
}
</style>
